import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function AlcoholDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Alcohol/Substance Misuse Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please confirm if the Client has:</Question>
                    <br />
                    <ReferrableQuestionWrapper isReferred={questions.clientAdvisedTo.referToAttachments}>
                        <Question>Been advised to reduce alcohol consumption:</Question>
                        <p>{questions.clientAdvisedTo.subQuestions.reduceAlcoholConsumption}</p>

                        <Question>Been advised to become dependent on alcohol:</Question>
                        <p>{questions.clientAdvisedTo.subQuestions.becomeDependant}</p>

                        <Question>Any history of alcohol dependence:</Question>
                        <p>{questions.clientAdvisedTo.subQuestions.historyOfDependence}</p>

                        {(
                            questions.clientAdvisedTo.subQuestions.reduceAlcoholConsumption === 'Yes' ||
                            questions.clientAdvisedTo.subQuestions.becomeDependant === 'Yes' ||
                            questions.clientAdvisedTo.subQuestions.historyOfDependence === 'Yes'
                        )
                            && (
                                <>
                                    <Question>If yes to any of the above, please provide details to include date & average weekly alcohol consumption at that time:</Question>
                                    <OutputDetails
                                        details={questions.clientAdvisedTo.subQuestions.details}
                                    />
                                </>
                            )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Has the Client a history of Substance use?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.historyOfSubstanceAbuse.referToAttachments}>
                        <p>{questions.historyOfSubstanceAbuse.value}</p>
                        {questions.historyOfSubstanceAbuse.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details of substances used:</Question>
                                <br />
                                <Question
                                    answer={questions.historyOfSubstanceAbuse.subQuestions.substanceUsed}
                                >
                                    Substance used:
                                </Question>
                                <br />
                                <Question
                                    answer={formatDateMonthYear(questions.historyOfSubstanceAbuse.subQuestions.dateFirstUsed)}
                                >
                                    Date First Used:
                                </Question>
                                <br />
                                <Question
                                    answer={formatDateMonthYear(questions.historyOfSubstanceAbuse.subQuestions.dateLastUsed)}
                                >
                                    Date Last Used:
                                </Question>
                                <br />
                                <Question
                                    answer={questions.historyOfSubstanceAbuse.subQuestions.frequencyOfUse}
                                >
                                    Frequency of use:
                                </Question>
                                <br />
                                <Question
                                    answer={questions.historyOfSubstanceAbuse.subQuestions.methodOfUse}
                                >
                                    Method:
                                </Question>
                                <br />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Has your patient sought or been recommended to undergo treatment?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentProvided.referToAttachments}>
                        <p>{questions.treatmentProvided.value}</p>
                        {questions.treatmentProvided.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details including dates & duration of treatment:</Question>
                                <OutputDetails
                                    details={questions.treatmentProvided.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Has your patient always been compliant with recommended treatment and follow-ups?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.compliantWithTreatment.referToAttachments}>
                        <p>{questions.compliantWithTreatment.value}</p>

                        <Question
                            show={questions.compliantWithTreatment.value === 'No'}
                            answer={questions.compliantWithTreatment.details}
                        >
                            If no, please provide full details:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Is there a history of relapse(s)?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.historyOfRelapse.referToAttachments}>
                        <p>{questions.historyOfRelapse.value}</p>
                        {questions.historyOfRelapse.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details including the date and duration of relapse:</Question>
                                <OutputDetails
                                    details={questions.historyOfRelapse.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Is your patient currently fully abstinent?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.fullyAbstinentAtPresent.referToAttachments}>
                        <p>{questions.fullyAbstinentAtPresent.value}</p>

                        <Question
                            show={questions.fullyAbstinentAtPresent.value === 'Yes'}
                            answer={questions.fullyAbstinentAtPresent.subQuestions.duration}
                        >
                            If yes, please confirm duration of abstinence:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Please provide the result of any laboratory testing including LFTs, MCV:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.labResults.referToAttachments}>
                        <OutputDetails
                            details={questions.labResults.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='8'>
                    <Question>Are there any biopsychosocial factors present which may influence your patient’s recovery?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.factorsInfluencingRecovery.referToAttachments}>
                        <p>{questions.factorsInfluencingRecovery.value}</p>

                        <Question
                            show={questions.factorsInfluencingRecovery.value === 'Yes'}
                            answer={questions.factorsInfluencingRecovery.details}
                        >
                            If yes, please provide details:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='9'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}